module.exports = __webpack_public_path__ + "static/media/log.d9eeded6.svg";